<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import ModalService from '@/modules/core/ui/services/ModalService';
import { UserConsentEvent } from '@/modules/policyconsent/events/UserConsentEvent';
import PolicyConsentModal from '@/modules/policyconsent/components/PolicyConsentModal.vue';
import { AuthUserEvent } from '@/modules/auth/events/AuthUserEvent';
import { AuthRoute } from '@/modules/auth/routes/auth.routes';
import { HandleApiSessionMismatchMixin } from '@/modules/auth/mixins/HandleApiSessionMismatchMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'App',
  mixins: [HandleApiSessionMismatchMixin],
  events() {
    return {
      [UserConsentEvent.NEEDS_POLICY_CONSENT_REQUESTED]: this.showOnConsentModal,
      [AuthUserEvent.USER_UNAUTHORIZED]: this.goToLoginPage
    };
  },
  methods: {
    goToLoginPage() {
      this.$router.push({ name: AuthRoute.LOGIN.name });
    },
    showOnConsentModal() {
      ModalService.show({
        parent: this,
        component: PolicyConsentModal,
        fullScreen: true,
        canCancel: false
      });
    }
  }
};
</script>
